
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/location/[slug]",
      function () {
        return require("private-next-pages/location/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/location/[slug]"])
      });
    }
  